import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { getUserInfo } from '@/api'

Vue.use(Vuex)

const state = {
    configData: {},
    userInfo: {},
    token: undefined
}

const mutations = {
    'SET_CONFIG_DATA': (state, data) => {
        state.configData = data;
    },
    'SET_USER_INFO': (state, payload) => {
        state.userInfo = payload;
    },
    'SET_TOKEN': (state, payload) => {
        state.token = payload;
    }
}

const actions = {
    addView({ dispatch }, view) {
        dispatch('addVisitedView', view)
        dispatch('addCachedView', view)
    },
    addVisitedView({ commit }, view) {
        commit('ADD_VISITED_VIEW', view)
    },
    // delAllCachedViews({ commit, state }) {
    //     return new Promise(resolve => {
    //         commit('DEL_ALL_CACHED_VIEWS')
    //         resolve([...state.cachedViews])
    //     })
    // },

    setConfigData({ commit }, data) {
        commit('SET_CONFIG_DATA', data)
    },
    setUserInfo({ commit }, data) {
        commit('SET_USER_INFO', data)
    },
    setToken({ commit }, data) {
        commit('SET_TOKEN', data);
        if (data) {
            getUserInfo().then(res => {
                commit('SET_USER_INFO', res)
            })
        }
    }
}

const getters = {
    configData: state => state.configData,
    userInfo: state => state.userInfo,
    token: state => state.token
}

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state,
    mutations,
    actions,
    getters
})

export default store
